(function () {
	"use strict";

	/* @preserve
	 * https://github.com/Elkfox/Ajaxinate
	 * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
	 * MIT License (do not remove above copyright!)
	 */

	function Ajaxinate(options) {
		const settings = options || {};

		this.settings = Object.assign(
			{
				method: "click",
				container: "#AjaxinateContainer",
				pagination: "#AjaxinatePagination",
				offset: 0,
				loadingText: "Loading...",
				callback: null
			},
			settings
		);

		this.addScrollListeners = this.addScrollListeners.bind(this);
		this.addClickListener = this.addClickListener.bind(this);
		this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
		this.preventMultipleClicks = this.preventMultipleClicks.bind(this);
		this.removeClickListener = this.removeClickListener.bind(this);
		this.removeScrollListener = this.removeScrollListener.bind(this);
		this.removePaginationElement = this.removePaginationElement.bind(this);
		this.destroy = this.destroy.bind(this);

		this.containerElement = document.querySelector(
			this.settings.container
		);

		this.paginationElement = document.querySelector(
			this.settings.pagination
		);

		this.initialize();
	}

	Ajaxinate.prototype.initialize = function () {
		if (!this.containerElement || !this.paginationElement) {
			return;
		}

		if (this.settings.method === "click") {
			this.addClickListener();
		} else {
			this.addScrollListeners();
		}
	};

	Ajaxinate.prototype.addScrollListeners = function () {
		if (!this.paginationElement) {
			return;
		}

		document.addEventListener(
			"scroll",
			this.checkIfPaginationInView
		);

		window.addEventListener(
			"resize",
			this.checkIfPaginationInView
		);

		window.addEventListener(
			"orientationchange",
			this.checkIfPaginationInView
		);
	};

	Ajaxinate.prototype.addClickListener = function () {
		if (!this.paginationElement) {
			return;
		}

		this.nextPageLinkElement =
			this.paginationElement.querySelector("a");

		this.clickActive = true;

		if (
			this.nextPageLinkElement &&
			typeof this.nextPageLinkElement.addEventListener === "function"
		) {
			this.nextPageLinkElement.addEventListener(
				"click",
				this.preventMultipleClicks
			);
		}
	};

	Ajaxinate.prototype.preventMultipleClicks = function (event) {
		event.preventDefault();

		if (!this.clickActive || !this.nextPageLinkElement) {
			return;
		}

		this.clickActive = false;

		this.nextPageUrl = this.nextPageLinkElement.href;

		const loadingText =
			this.settings.loadingText || "Loading...";

		this.nextPageLinkElement.innerText = loadingText;

		this.loadMore();
	};

	Ajaxinate.prototype.checkIfPaginationInView = function () {
		if (!this.paginationElement) {
			return;
		}

		const top =
			this.paginationElement.getBoundingClientRect().top -
			this.settings.offset;

		const bottom =
			this.paginationElement.getBoundingClientRect().bottom +
			this.settings.offset;

		if (
			top <= window.innerHeight &&
			bottom >= 0
		) {
			this.nextPageLinkElement =
				this.paginationElement.querySelector("a");

			this.removeScrollListener();

			if (!this.nextPageLinkElement) {
				return;
			}

			this.nextPageLinkElement.innerText =
				this.settings.loadingText;

			this.nextPageUrl =
				this.nextPageLinkElement.href;

			this.loadMore();
		}
	};

	Ajaxinate.prototype.loadMore = function () {
		if (!this.nextPageUrl) {
			return;
		}

		this.request = new XMLHttpRequest();

		this.request.onreadystatechange = function () {
			if (this.request.readyState !== 4) {
				return;
			}

			if (this.request.status !== 200) {
				this.clickActive = true;
				return;
			}

			if (!this.request.responseXML) {
				this.clickActive = true;
				return;
			}

			const container =
				this.request.responseXML.querySelector(
					this.settings.container
				);

			const pagination =
				this.request.responseXML.querySelector(
					this.settings.pagination
				);

			if (!container) {
				this.clickActive = true;
				return;
			}

			this.containerElement.insertAdjacentHTML(
				"beforeend",
				container.innerHTML
			);

			if (!pagination) {
				this.removePaginationElement();
				return;
			}

			this.paginationElement.innerHTML =
				pagination.innerHTML;

			if (
				this.settings.callback &&
				typeof this.settings.callback === "function"
			) {
				this.settings.callback(
					this.request.responseXML
				);
			}

			this.initialize();
		}.bind(this);

		this.request.open(
			"GET",
			this.nextPageUrl
		);

		this.request.responseType = "document";

		this.request.send();
	};

	Ajaxinate.prototype.removeClickListener = function () {
		if (
			this.nextPageLinkElement &&
			typeof this.nextPageLinkElement.removeEventListener ===
			"function"
		) {
			this.nextPageLinkElement.removeEventListener(
				"click",
				this.preventMultipleClicks
			);
		}
	};

	Ajaxinate.prototype.removePaginationElement = function () {
		if (this.paginationElement) {
			this.paginationElement.innerHTML = "";
		}

		this.destroy();
	};

	Ajaxinate.prototype.removeScrollListener = function () {
		document.removeEventListener(
			"scroll",
			this.checkIfPaginationInView
		);

		window.removeEventListener(
			"resize",
			this.checkIfPaginationInView
		);

		window.removeEventListener(
			"orientationchange",
			this.checkIfPaginationInView
		);
	};

	Ajaxinate.prototype.destroy = function () {
		if (this.settings.method === "click") {
			this.removeClickListener();
		} else {
			this.removeScrollListener();
		}

		return this;
	};

	customElements.get("ajaxinate-items") ||
		customElements.define(
			"ajaxinate-items",
			class extends HTMLElement {
				constructor() {
					super();
				}

				connectedCallback() {
					this.init();
				}

				init() {
					this.endlessScroll = null;

					const id = this?.dataset.ajaxinateId;

					const container =
						`#AjaxinateLoop[data-ajaxinate-id="${id}"]`;

					const pagination =
						`#AjaxinatePagination[data-ajaxinate-id="${id}"]`;

					if (this?.children.length > 0) {
						this.endlessScroll = new Ajaxinate({
							container: container,
							pagination: pagination,
							method: "click"
						});
					}
				}

				reinit() {
					this.unload();
					this.init();
				}

				unload() {
					if (this.endlessScroll !== null) {
						this.endlessScroll.settings.method = "click";
						this.endlessScroll.destroy();
						this.endlessScroll = null;
					}
				}

				disconnectedCallback() {
					this.unload();
				}
			}
		);
})();